<div class="breadcrumb-title" *ngIf="title">
  <h1 class="bc-title">{{ title }}<span class="bc-title-bar"></span></h1>
</div>
